import gql from 'graphql-tag';
import { apollo } from 'src/features';

const query = gql`
fragment msg on Message {
    id
    sender
    insertedAt
    body
    isRead
    customerId
    customerType
    operatorId
    activityId
    receiver
    to
    from
    copies
    auto
    avatarUrl
    attachments {
      title
      type
      size
      original
      preview
      ext
    }
}

query messagesFeedQuery($cursor: String!, $limit: Int!, $activityId: String, $channelId: ID ) {
  messagesFeed(cursor: $cursor, limit: $limit, activityId: $activityId, channelId: $channelId) {
    messages {
      ...msg
    }
    pageInfo {
       cursor
       hasNextPage
    }
  }
}`;

function getMessagesByPage({
  cursor,
  limit,
  channelId,
  activityId,
}) {
  return apollo.client.query({
    variables: {
      cursor,
      limit: parseInt(limit, 10),
      channelId,
      activityId,
    },
    query,
    fetchPolicy: 'network-only',
  }).then((res) => res.data.messagesFeed);
}

export default getMessagesByPage;
